//Models
PJQ.models.bidForms.Template = PJQ.models.BaseModel.extend({
	idAttribute: "templateId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'templates',
				value: this.id
			}
		], [
			{
				parameter: 'projectId',
				value: this.get('projectId')
			},
			{
				parameter: 'groupIds',
				value: this.get('groupIds')
			}
		])
	},
	parse: function (template) {
		this.groupBidForms = new PJQ.collections.bidForms.GroupBidForms({
			groupBidForms: template ? template.groupBidForms : [],
			projectBidForm: template ? template.projectBidForm : null
		});
		return template;
	}
});

PJQ.models.bidForms.BidFormSummary = PJQ.models.BaseModel.extend({
	idAttribute: "bidFormId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.id
			}
		])
	},
	parse: function (bidForm) {
		if (bidForm.managedBy != null) {
			this.managedBy = new PJQ.models.contacts.Contact(bidForm.managedBy);
		}
		else {
			this.managedBy = null;
		}
		return bidForm;
	}
});

PJQ.models.bidForms.ProjectBidForm = PJQ.models.BaseModel.extend({
	idAttribute: "bidFormId",
	endpoint: function () {
		if (this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidforms',
					value: this.id
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.id
			}
		]);
	},
	beforeConstruct: function (attributes) {
		this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
		this.bonding = new PJQ.collections.bidForms.Bonding([], {bidFormId: attributes.bidFormId});
		this.certifications = new PJQ.collections.bidForms.Certifications([], {bidFormId: attributes.bidFormId});
		this.laborRates = new PJQ.collections.bidForms.LaborRates([], {bidFormId: attributes.bidFormId});
	},
	parse: function (bidForm) {
		if (bidForm.acknowledgements) {
			this.acknowledgements.reset(bidForm.acknowledgements);
		}
		if (bidForm.bonding) {
			this.bonding.reset(bidForm.bonding);
		}

		if (bidForm.certifications) {
			this.certifications.reset(bidForm.certifications);
		}

		if (bidForm.laborRates) {
			this.laborRates.reset(bidForm.laborRates);
		}

		return bidForm;
	},
	updateAcknowledgementDeleted: function (cid, isDeleted) {
		let acknowledgement = this.acknowledgements.get({cid: cid});
		if (acknowledgement.id == null)
			this.acknowledgements.remove(acknowledgement);
		else
			acknowledgement.set('isDeleted', isDeleted);
	},
	updateBondingDeleted: function (cid, isDeleted) {
		let bonding = this.bonding.get({cid: cid});
		if (bonding.id == null)
			this.bonding.remove(bonding);
		else
			bonding.set('isDeleted', isDeleted);
	},
	updateCertificationDeleted: function (cid, isDeleted) {
		let certification = this.certifications.get({cid: cid});
		if (certification.id == null)
			this.certifications.remove(certification);
		else
			certification.set('isDeleted', isDeleted);
	},
	updateLaborRateDeleted: function (cid, isDeleted) {
		let laborRate = this.laborRates.get({cid: cid});
		if (laborRate.id == null)
			this.laborRates.remove(laborRate);
		else
			laborRate.set('isDeleted', isDeleted);
	},
	beforeSave: function () {
		this.set('acknowledgements', this.acknowledgements.getChangedModels());
		this.set('bonding', this.bonding.getChangedModels());
		this.set('certifications', this.certifications.getChangedModels());
		this.set('laborRates', this.laborRates.getChangedModels());
	}
});

PJQ.models.bidForms.GroupBidForm = PJQ.models.bidForms.ProjectBidForm.extend({
	beforeConstruct: function (attributes) {
		if (attributes.bidPackage != null) {
			this.bidPackage = new PJQ.models.bidPackages.BidPackage(attributes.bidPackage);
		}
		else {
			this.bidPackage = null;
		}

		this.lineItems = new PJQ.collections.bidForms.LineItems([], {bidFormId: attributes.bidFormId});
		this.alternates = new PJQ.collections.bidForms.Alternates([], {bidFormId: attributes.bidFormId});
		this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
		this.bidders = new PJQ.collections.bidForms.Bidders([], {bidFormId: attributes.bidFormId});

		if (attributes.managedBy != null) {
			this.managedBy = new PJQ.models.contacts.Contact(attributes.managedBy);
		}
		else {
			this.managedBy = null;
		}
	},
	parse: function (bidForm) {
		if (bidForm.lineItems) {
			this.lineItems.reset(bidForm.lineItems);
		}

		if (bidForm.alternates) {
			this.alternates.reset(bidForm.alternates);
		}

		if (bidForm.acknowledgements) {
			this.acknowledgements.reset(bidForm.acknowledgements);
		}

		if(bidForm.bidPackageId > 0 && bidForm.bidPackage){
			this.bidPackage = new PJQ.models.bidPackages.BidPackage(bidForm.bidPackage)
		}

		if (bidForm.bidders) {
			this.bidders.reset(bidForm.bidders);

			if (bidForm.managedBy != null) {
				this.managedBy = new PJQ.models.contacts.Contact(bidForm.managedBy);
			}
			else {
				this.managedBy = null;
			}
		}

		return bidForm;
	},
	getDueDate: function () {
		let dueDate = this.get('dueDate');
		return dueDate == null ? null : new Date(dueDate);
	},
	preview: function (collection, opts) {
		if (!opts)
			opts = {};
		opts.model = this;
		opts.collection = collection;
		if (this.projectBidForm) {
			opts.projectBidForm = this.projectBidForm;
		}
		new PJQ.views.bidForms.BidFormPreviewModal(opts);
	},
	updateLineItemDeleted: function (cid, isDeleted) {
		let lineItem = this.lineItems.get({cid: cid});
		if (lineItem.id == null)
			this.lineItems.remove(lineItem);
		else
			lineItem.set('isDeleted', isDeleted);
	},
	updateAlternateDeleted: function (cid, isDeleted) {
		let alternate = this.alternates.get({cid: cid});
		if (alternate.id == null)
			this.alternates.remove(alternate);
		else
			alternate.set('isDeleted', isDeleted);
	},
	calculateTotal: function (isIncludeAlternates = false, forceSubmitted) {
		let lineItems = this.lineItems.models,
			total = 0;
		for (let i = 0; i < lineItems.length; i++) {
			total += lineItems[i].calculateTotal(forceSubmitted);
		}

		if (isIncludeAlternates) {
			let alternates = this.alternates.models;
			for (let i = 0; i < alternates.length; i++) {
				if (alternates[i].get('isLevel')) {
					total += alternates[i].calculateTotal(forceSubmitted);
				}
			}
		}
		return total;
	},
	beforeSave: function () {
		this.set('lineItems', this.lineItems.getChangedModels());
		this.set('alternates', this.alternates.getChangedModels());
		this.set('acknowledgements', this.acknowledgements.getChangedModels());
		this.set('managedBy', this.managedBy);

		if (!this.bidPackage)
			this.set('dueDate', null);
	}
});

PJQ.models.bidForms.LineItem = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'lineitems',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.lineItemTypes[0].name,
		isRequired: false,
		cost: 0,
		multiplier: 0
	},
	calculateTotal: function (forceSubmitted) {
		let masterUserId = PJQ.app.session.user?.get('masterUserId'),
			project = PJQ.app.session.project,
			isCompanyUser = project == null || (masterUserId === project.get('masterUserId')),
			cost = this.get('leveledCost') != null && forceSubmitted !== true && isCompanyUser ? this.get('leveledCost') : this.get('cost'),
			multiplier = this.get('leveledMultiplier') != null && forceSubmitted !== true && isCompanyUser ? this.get('leveledMultiplier') : this.get('multiplier');

		switch (this.get('type').toLowerCase()) {
			case "sum":
				return cost == null ? 0 : cost;
			default:
				return (cost == null ? 0 : cost) * (multiplier == null ? 0 : multiplier);
		}
	}
});

PJQ.models.bidForms.Alternate = PJQ.models.bidForms.LineItem.extend({
	idAttribute: 'id',
	beforeConstruct: function (attributes) {
		this.choices = new PJQ.collections.customFields.CustomFieldChoices(attributes.choices);
	},
	parse: function (alternate) {
		this.choices.reset(alternate.choices);
		return alternate;
	},
	getCustomFieldType: function () {
		let result = {
			type: '',
			isMultipleChoice: false
		}
		switch (this.get('type').toLowerCase()) {
			case 'money':
			case 'date':
			case 'text':
			case 'textarea':
				result.type = this.get('type').toUpperCase();
				break;
			case 'single choice':
			case 'multiple choice':
				result.isMultipleChoice = true;
				result.type = PJQ.constants.customFields.fieldTypes.CHOICE;
				break;
			case 'numeric':
				result.type = PJQ.constants.customFields.fieldTypes.INT;
				break;
			case 'yes/no':
				result.type = PJQ.constants.customFields.fieldTypes.BOOL;
				break;
		}
		return result;
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'alternates',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.alternateTypes[0].name,
		isRequired: false,
		cost: 0,
		multiplier: 0
	}
});

PJQ.models.bidForms.Acknowledgement = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	beforeConstruct: function (attributes) {
		this.choices = new PJQ.collections.customFields.CustomFieldChoices(attributes.choices);
	},
	parse: function (acknowledgement) {
		this.choices.reset(acknowledgement.choices);
		return acknowledgement;
	},
	getCustomFieldType: function () {
		let result = {
			type: '',
			isMultipleChoice: false
		}
		switch (this.get('type').toLowerCase()) {
			case 'money':
			case 'date':
			case 'text':
			case 'textarea':
				result.type = this.get('type').toUpperCase();
				break;
			case 'single choice':
			case 'multiple choice':
				result.isMultipleChoice = true;
				result.type = PJQ.constants.customFields.fieldTypes.CHOICE;
				break;
			case 'numeric':
				result.type = PJQ.constants.customFields.fieldTypes.INT;
				break;
			case 'yes/no':
				result.type = PJQ.constants.customFields.fieldTypes.BOOL;
				break;
		}
		return result;
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'acknowledgements',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.acknowledgementTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.Bonding = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'bonding',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.bondingTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.Certification = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'certifications',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.certificationTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.LaborRate = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'laborrates',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.laborRateTypes[0],
		isRequired: false
	}
});

//Collections
PJQ.collections.bidForms.Templates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Template,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'templates'
			}
		])
	}
});

PJQ.collections.bidForms.BidFormsSummary = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.BidFormSummary,
	endpoint: function () {
		if (this.options.templateId > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'templates',
					value: this.options.templateId
				},
				{
					endpoint: 'summary'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.projectId
			},
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'summary'
			}
		]);
	},
	export: function (groupIds) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.projectId
				},
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'summary'
				}
			], [
				{
					parameter: 'export',
					value: true
				},
				{
					parameter: 'groupIds',
					value: groupIds
				}
			]),
			isApi2: true
		}).get().done(_.bind(function (response) {
			PJQ.files.downloadFile(response.url, {
				isEndpoint: false
			});
		}, this)).fail(_.bind(function (xhr, err, result) {
		}, this));
	},
	deleteList: function (groupIds, callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.projectId
				},
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'delete'
				}
			], [
				{
					parameter: 'groupIds',
					value: groupIds
				}
			]),
			isApi2: true
		}).delete().done(_.bind(function (response) {
			callback();
		}, this)).fail(_.bind(function (xhr, err, result) {
		}, this));
	}
});

PJQ.collections.bidForms.GroupBidForms = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.GroupBidForm,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'bidforms'
			}
		]);
	},
	beforeConstruct: function (models) {
		this.projectBidForm = new PJQ.models.bidForms.ProjectBidForm(models.projectBidForm ? models.projectBidForm : {});
	},
	parse: function (response) {
		if (response.projectBidForm)
			this.projectBidForm.set(response.projectBidForm);
		return response.groupBidForms;
	},
	getSelectedGroupIds: function () {
		let selectedGroupIds = [];
		_.each(this.models, function (model) {
			selectedGroupIds.push(model.get('group').groupId);
		});
		return selectedGroupIds;
	},
	addGroups: function (groups, radius, success, error) {
		let groupIds = [];
		_.each(groups, function (group) {
			groupIds.push(group.get('groupId'));
		});

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'bidders'
			}
		]);
		let request = new PJQ.ajax.Request({
			endpoint: endpoint,
			data: {
				projectId: PJQ.app.session.project.id,
				groupIds: groupIds,
				radius: radius
			}
		});
		request.post().done(_.bind(function (data) {
			this.fetchReset();
			success(data);
		}, this)).fail(function () {
			error();
		});
	}
});

PJQ.collections.bidForms.LineItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.LineItem,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'lineitems'
			}
		])
	}
});

PJQ.collections.bidForms.Alternates = PJQ.collections.bidForms.LineItems.extend({
	model: PJQ.models.bidForms.Alternate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'alternates'
			}
		])
	}
});

PJQ.collections.bidForms.Acknowledgements = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Acknowledgement,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'acknowledgements'
			}
		])
	}
});

PJQ.collections.bidForms.Bonding = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Bonding,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'bonding'
			}
		])
	}
});

PJQ.collections.bidForms.Certifications = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Certification,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'certifications'
			}
		])
	}
});

PJQ.collections.bidForms.LaborRates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.LaborRate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'laborrates'
			}
		])
	}
});
